import React,{useState} from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import {formatDate} from '../../utils/formatDate';
import {useActiveEvents} from '../../hooks/useActiveEvents';

const {FiChevronLeft,FiChevronRight,FiCalendar,FiMapPin}=FiIcons;

const TYPES={
  examen: 'Examen',
  torneo: 'Torneo',
  convivio: 'Convivio',
  'clase-especial': 'Clase especial',
};

export default function EventCarousel({onOpen}) {
  const events=useActiveEvents()
    .filter(event=> new Date(`${event.eventDate}T${event.time}`)>=new Date())
    .sort((a,b)=> `${a.eventDate}${a.time}`.localeCompare(`${b.eventDate}${b.time}`))
    .slice(0,3);

  const [index,setIndex]=useState(0);

  if (!events.length) return null;

  const event=events[index];
  const move=(amount)=> setIndex((index+amount+events.length)%events.length);

  return (
    <section className="max-w-7xl mx-auto px-6 py-16">
      <div className="flex items-end justify-between mb-7">
        <div>
          <span className="text-red-500 font-black tracking-[.4em] uppercase text-[10px]">
            Agenda
          </span>
          <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter text-white mt-2">
            Próximos eventos
          </h2>
        </div>

        <div className="flex gap-2">
          <button
            onClick={()=> move(-1)}
            className="p-3 rounded-xl bg-white/5 hover:bg-red-600 text-white"
            aria-label="Evento anterior"
          >
            <SafeIcon icon={FiChevronLeft} />
          </button>
          <button
            onClick={()=> move(1)}
            className="p-3 rounded-xl bg-white/5 hover:bg-red-600 text-white"
            aria-label="Evento siguiente"
          >
            <SafeIcon icon={FiChevronRight} />
          </button>
        </div>
      </div>

      <div className="glass-card rounded-[2.5rem] overflow-hidden">
        <div className="p-7 md:p-10 min-h-56">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-8">
            <div>
              <span className="text-yellow-400 text-[10px] font-black uppercase tracking-widest">
                {TYPES[event.type]}
              </span>

              <button
                onClick={()=> onOpen(event)}
                className="block text-left group"
              >
                <h3 className="text-3xl font-black uppercase tracking-tight text-white mt-3 group-hover:text-red-400 transition-colors">
                  {event.title}
                </h3>
              </button>

              <p className="text-white/65 mt-3 max-w-2xl whitespace-pre-line">
                {event.description}
              </p>
            </div>

            <div className="space-y-3 text-xs font-bold uppercase tracking-widest text-white/70">
              <p>
                <SafeIcon icon={FiCalendar} className="inline text-red-500 mr-2" />
                {formatDate(event.eventDate)} · {event.time}
              </p>

              <p>
                <SafeIcon icon={FiMapPin} className="inline text-red-500 mr-2" />
                {event.place}
              </p>
            </div>
          </div>

          <button
            onClick={()=> onOpen(event)}
            className="mt-8 text-red-400 hover:text-white text-[10px] font-black uppercase tracking-widest"
          >
            Ver calendario →
          </button>
        </div>
      </div>
    </section>
  );
}